export const enum EInsuranceMetaStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  READY = 'ready',
  EXPIRED = 'expired',
}
